import React from 'react'
import { useTranslation } from 'react-i18next'
import TotalScansIcon from '../../icons/TotalScansIcon'
import BaseWidget from '../../components/common/BaseWidget'
import NumberWidget from '../../components/common/NumberWidget/NumberWidget'

const TotalScans = ({ value, isLoading }) => {
  const { t } = useTranslation()

  return (
    <BaseWidget carousel={false}>
      <NumberWidget
        isLoading={isLoading}
        key={'totalScans'}
        label={t('pages.copilotControl.widgets.totalScans.title')}
        icon={TotalScansIcon}
        value={value}
        tooltipText={t('pages.copilotControl.widgets.totalScans.tooltip')}
      />
    </BaseWidget>
  )
}

export default TotalScans
